import React, { useMemo } from 'react';
import { Chart, ClockTemplate, CountWidget, WithLoadingComponent, SVGLoader } from "components/shared";
import { CustomKPIHoc } from 'components/pages';
import { FlexSectionContainer } from 'components/layout';
import { ReportingService } from 'services/http';
import Utils, { REPORTING_ENDPOINTS_SUFFIXES } from "utils";

export const ActivityKapis = () => {

    const filterSearchParam = JSON.parse(new URLSearchParams(window.location.search).get("filter"));

    return (
        <>
            <FlexSectionContainer title="Activity KPIs">
                <CustomKPIHoc
                    chart="column"
                    title="Posts KPI"
                    size={{ height: 300, width: "50%" }}
                    httpService={() => ReportingService.getInterventionActivityKPIs(Utils.buildFilterCriteria(filterSearchParam))}
                    downloadReportService={(type) => ReportingService.downloadKpiReport(REPORTING_ENDPOINTS_SUFFIXES.ACTIVITY_INTERVENTION, Utils.buildFilterCriteria(filterSearchParam), type)}
                />
                <CustomKPIHoc
                    chart="pie"
                    title="Clients KPI"
                    size={{ height: 300, width: "50%" }}
                    httpService={() => ReportingService.getClientActivityKPIs(Utils.buildFilterCriteria(filterSearchParam))}
                    downloadReportService={(type) => ReportingService.downloadKpiReport(REPORTING_ENDPOINTS_SUFFIXES.ACTIVITY_CLIENTS, Utils.buildFilterCriteria(filterSearchParam), type)}
                />
            </FlexSectionContainer>

            <FlexSectionContainer title="Intervention by category">
                <CustomKPIHoc
                    chart="pie"
                    title="Tags KPI"
                    size={{ height: 800, width: "100%" }}
                    httpService={() => ReportingService.getInterventionActivityByCategory(Utils.buildFilterCriteria(filterSearchParam))}
                    downloadReportService={(type) => ReportingService.downloadKpiReport(REPORTING_ENDPOINTS_SUFFIXES.ACTIVITY_INTERVENTION_TAGS, Utils.buildFilterCriteria(filterSearchParam), type)}
                />

            </FlexSectionContainer>

            <FlexSectionContainer title="Daily Interventions Activity">
                <CustomKPIHoc
                    timeline
                    chart="spline"
                    title="Daily Posts KPI"
                    size={{ height: 450, width: "100%" }}
                    httpService={() => ReportingService.getInterventionDailyActivity(Utils.buildFilterCriteria(filterSearchParam))}
                    downloadReportService={(type) => ReportingService.downloadKpiReport(REPORTING_ENDPOINTS_SUFFIXES.ACTIVITY_DAILY_INTERVENTION, Utils.buildFilterCriteria(filterSearchParam), type)}
                />
            </FlexSectionContainer>

            {/* <FlexSectionContainer>
                <div style={{ width: "25%" }}>
                    <ClockTemplate title="Log on hours" content="398H 34mn" />
                </div>
                <div style={{ width: "25%" }}>
                    <CountWidget
                        title="Backlog"
                        aboveContent={{ content: 213, label: "Total Tasks issued" }}
                        belowContent={{ content: 90, label: "Total Tasks defered" }} />
                </div>
            </FlexSectionContainer> */}

        </>
    );
}